<template>
  <div>
    <JobApplicationForm :hideAreaOfInterest="true" :jobId="jobId" :jobCategory="jobCategory" />
  </div>
</template>

<script>
import JobApplicationForm from "../../components/Forms/JobApplicationForm.vue";

export default {
  name: "Apply",
  components: { JobApplicationForm },
  data() {
    return { jobId: null, jobCategory: null };
  },
  beforeMount() {
    this.jobId = this.$route.query.id;
    this.jobCategory = this.$route.query.cat;
  }
};
</script>
